<section class="mb-20">
  <div class="mt-5 relative">
    <div class="w-full bg-[#285CA5] h-[124px] rounded-t-xl flex items-center justify-end gap-3">
      <div class="pr-8">
      </div>
    </div>

    <div class="w-full h-[124px] sm:h-[150px] flex items-center">
      <div class="ml-32 sm:ml-64 flex items-start justify-between w-full">
        <div>
          <div class="flex items-center space-x-3">
            <div class="w-[17px] h-[17px] rounded-full" [style.backgroundColor]="getServiceDurationColor()"></div>
            <p class="text-lg sm:text-2xl font-bold m-0 text-[#000000A6]">
              {{ nurse?.name }}
            </p>
            <span class="text-[#526ED3] text-sm sm:text-base font-medium">
              {{ getEmployeeDisplayNumber() }}</span>

          </div>
          <p class="text-[#6B6D80] text-xs sm:text-sm font-medium m-0 pt-2">
            Registered on {{ nurse?.registrationDate | date : "MMM d, y" }}
          </p>
        </div>
      </div>
    </div>
    <div class="w-[100px] h-[100px] sm:w-[180px] sm:h-[180px] rounded-full absolute top-16 md:top-10 left-4 sm:left-10">
      <img class="object-cover w-full h-full rounded-full bg-gray-100"
        src="{{ nurse?.profilePic || 'https://api.iconify.design/mdi/account.svg?color=%239ca3af' }}"
        alt="Nurse Profile" />
    </div>
  </div>

  <div class="flex items-center justify-between mt-10">
    <div class="flex items-center space-x-5">
      <div class="w-[40px] h-[40px] bg-[#285CA5] rounded-full flex items-center justify-center cursor-pointer"
        (click)="goBack()">
        <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M7.58893 1.16156C7.91437 1.487 7.91437 2.01463 7.58893 2.34007L3.17819 6.75081H12.833C13.2932 6.75081 13.6663 7.12391 13.6663 7.58415C13.6663 8.04438 13.2932 8.41748 12.833 8.41748H3.17819L7.58893 12.8282C7.91437 13.1537 7.91437 13.6813 7.58893 14.0067C7.26349 14.3322 6.73586 14.3322 6.41042 14.0067L0.577085 8.1734C0.251649 7.84797 0.251649 7.32033 0.577085 6.99489L6.41042 1.16156C6.73586 0.836121 7.26349 0.836121 7.58893 1.16156Z"
            fill="white" />
        </svg>
      </div>
      <p class="text-xl text-[#000000A6] font-bold">
        {{ getMonthName(month) }} - {{ year }} Salary
      </p>
    </div>

    <button tuiButton type="button" appearance="primary" size="s" iconStart="@tui.file-text" (click)="exportPdf()">
      Export PDF
    </button>
  </div>

  <div class="flex items-center mt-2 space-x-20">
    <div class="flex flex-col">
      <p class="text-sm text-[#595959] font-medium mb-0">Number of Shifts</p>
      <p class="text-[#6B6D80] text-xl font-bold mt-0 pt-0">
        {{ salaryRecords.length }}
      </p>
    </div>
    <div class="flex flex-col">
      <p class="text-sm text-[#595959] font-medium mb-0">Net Salary</p>
      <p class="text-[#285CA5] text-xl font-bold mt-0 pt-0">
        {{getNetSalary()}}LKR
      </p>
    </div>
  </div>

  <p class="text-[#3E4A58] text-base font-medium mt-0 pt-0">
    Attendance History
  </p>
  <div class="flex overflow-x-auto">
    <table tuiTable size="m" class="md:w-full">
      <thead>
        <tr>
          <th tuiTh style="background-color: #285ca5; color: white">Date</th>
          <th tuiTh style="background-color: #285ca5; color: white">Patient name</th>
          <th tuiTh style="background-color: #285ca5; color: white">Roster</th>
          <th tuiTh style="background-color: #285ca5; color: white">Meal Option</th>
          <th tuiTh style="background-color: #285ca5; color: white">Shift Type</th>
          <th tuiTh style="background-color: #285ca5; color: white">Address</th>
          <th tuiTh style="background-color: #285ca5; color: white">Shift Salary</th>
        </tr>
      </thead>
      <tbody tuiTbody>
        <!-- Loop through all dates in the month -->
        <ng-container *ngFor="let date of allMonthDates">
          <!-- Show off day row if no shifts -->
          <tr *ngIf="isOffDay(date)" [class.off-day-row]="true">
            <td tuiTd style="padding-top: 0; padding-bottom: 0">
              <div tuiCell="m">
                <p class="text-[#526ED3] text-sm">
                  {{ date | date : "dd MMM yyyy" }}
                </p>
              </div>
            </td>
            <td tuiTd style="padding-top: 0; padding-bottom: 0">
              <div tuiCell="m">
                <p class="text-[#191C30E5] text-sm">Off Day</p>
              </div>
            </td>
            <td tuiTd style="padding-top: 0; padding-bottom: 0">
              <div tuiCell="m">
                <p class="text-[#191C30E5] text-sm">-</p>
              </div>
            </td>
            <td tuiTd style="padding-top: 0; padding-bottom: 0">
              <div tuiCell="m">
                <p class="text-[#191C30E5] text-sm">-</p>
              </div>
            </td>
            <td tuiTd style="padding-top: 0; padding-bottom: 0">
              <div tuiCell="m">
                <p class="text-[#191C30E5] text-sm">-</p>
              </div>
            </td>
            <td tuiTd style="padding-top: 0; padding-bottom: 0">
              <div tuiCell="m">
                <p class="text-[#191C30E5] text-sm">-</p>
              </div>
            </td>
            <td tuiTd style="padding-top: 0; padding-bottom: 0">
              <div tuiCell="m">
                <p class="text-[#191C30E5] text-sm">LKR 0.00</p>
              </div>
            </td>
          </tr>

          <!-- Show all shifts for this date -->
          <ng-container *ngFor="let shift of getShiftsForDate(date); let i = index">
            <tr [class.multiple-shifts-row]="hasMultipleShifts(date) && i > 0">
              <td tuiTd style="padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#526ED3] text-sm" *ngIf="i === 0">
                    {{ date | date : "dd MMM yyyy" }}
                  </p>
                  <p class="text-[#526ED3] text-sm" *ngIf="i > 0">
                    <span class="text-gray-400">↳</span>
                  </p>
                </div>
              </td>
              <td tuiTd style="padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ shift.clientDetails?.name ?? 'Unavailable' }}
                  </p>
                </div>
              </td>
              <td tuiTd style="padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ shift.rooster }} Hour
                  </p>
                </div>
              </td>
              <td tuiTd style="padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">{{ shift.mealOption }}</p>
                </div>
              </td>
              <td tuiTd style="padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">{{ shift.shiftType }}</p>
                </div>
              </td>
              <td tuiTd style="padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ shift.address.length > 20 ? (shift.address | slice:0:40) + '...' : shift.address }}
                  </p>
                </div>
              </td>
              <td tuiTd style="padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    LKR {{ shift.salary | number : "1.2-2" }}
                  </p>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-container>

      </tbody>
    </table>
  </div>
</section>